(function () {

  /*
   * =========================================
   * GALLERY / CAROUSEL
   * =========================================
   */

  function initGallery(root) {
    if (!root || root.dataset.lpGalleryReady === 'true') return;

    var track = root.querySelector('[data-lp-gallery-track]');
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-lp-gallery-dot]')
    );
    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-lp-gallery-item]')
    );

    if (!track || !items.length) return;

    root.dataset.lpGalleryReady = 'true';


    function setActive(index) {
      if (!dots.length) return;

      dots.forEach(function (dot, i) {
        var active = i === index;

        dot.classList.toggle('is-active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }


    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (!items[index]) return;

        track.scrollTo({
          left: items[index].offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });

        setActive(index);
      });
    });


    var ticking = false;

    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;

        ticking = true;

        window.requestAnimationFrame(function () {
          var bestIndex = 0;
          var bestDistance = Infinity;

          items.forEach(function (item, index) {
            var distance = Math.abs(
              (item.offsetLeft - track.offsetLeft) - track.scrollLeft
            );

            if (distance < bestDistance) {
              bestDistance = distance;
              bestIndex = index;
            }
          });

          setActive(bestIndex);
          ticking = false;
        });
      },
      { passive: true }
    );


    setActive(0);
  }


  function initAllGalleries(scope) {
    var target = scope || document;

    target
      .querySelectorAll('[data-lp-gallery]')
      .forEach(initGallery);
  }


  /*
   * =========================================
   * SHOPIFY-HOSTED VIDEO
   * =========================================
   *
   * Delegated click listener so it works:
   * - in normal preview
   * - in Customize
   * - after Shopify reloads a section
   * - without inline JS
   */

  document.addEventListener('click', function (event) {

    var playButton = event.target.closest('[data-lp-video-play]');

    if (!playButton) return;

    event.preventDefault();
    event.stopPropagation();

    var shell = playButton.closest('[data-lp-video-shell]');

    if (!shell) return;

    var video = shell.querySelector('video');
    var poster = shell.querySelector('[data-lp-video-poster]');

    if (!video) {
      console.warn('LP Gallery: video element not found.');
      return;
    }


    /*
     * Pause other LP gallery videos.
     */
    document
      .querySelectorAll('[data-lp-video-shell] video')
      .forEach(function (otherVideo) {
        if (otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
        }
      });


    /*
     * Important:
     * call play() FIRST, directly from the user's click.
     * Do not delay it behind promises/timeouts/layout work.
     */
    var playPromise;

    try {
      playPromise = video.play();
    } catch (error) {
      console.error('LP Gallery video play error:', error);
      video.controls = true;
      return;
    }


    if (playPromise && typeof playPromise.then === 'function') {

      playPromise
        .then(function () {

          if (poster) {
            poster.classList.add('is-hidden');
          }

          playButton.classList.add('is-hidden');

          /*
           * Once playing, expose the normal controls
           * so pause / volume / scrub still work.
           */
          video.controls = true;

        })
        .catch(function (error) {

          console.error('LP Gallery video playback rejected:', error);

          /*
           * Fallback:
           * expose the real video and native controls.
           * The customer can then use the browser's
           * native play button.
           */
          if (poster) {
            poster.classList.add('is-hidden');
          }

          playButton.classList.add('is-hidden');

          video.controls = true;

        });

    } else {

      if (poster) {
        poster.classList.add('is-hidden');
      }

      playButton.classList.add('is-hidden');
      video.controls = true;

    }

  });


  /*
   * If the block is configured WITHOUT the
   * custom play button, show native controls.
   */
  function initNativeVideoControls(scope) {
    var target = scope || document;

    target
      .querySelectorAll('[data-lp-show-native-controls]')
      .forEach(function (marker) {

        var shell = marker.closest('[data-lp-video-shell]');
        var video = shell ? shell.querySelector('video') : null;

        if (video) {
          video.controls = true;
        }

      });
  }


  /*
   * =========================================
   * YOUTUBE / VIMEO
   * =========================================
   */

  document.addEventListener('click', function (event) {

    var button = event.target.closest('[data-lp-external-play]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var shell = button.closest('[data-lp-external-shell]');

    if (!shell) return;

    var type = button.getAttribute('data-video-type');
    var id = button.getAttribute('data-video-id');

    if (!type || !id) return;

    var src = '';

    if (type === 'youtube') {

      src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(id) +
        '?autoplay=1&playsinline=1&rel=0';

    } else if (type === 'vimeo') {

      src =
        'https://player.vimeo.com/video/' +
        encodeURIComponent(id) +
        '?autoplay=1&playsinline=1';

    } else {

      return;

    }


    var iframe = document.createElement('iframe');

    iframe.src = src;
    iframe.title =
      button.getAttribute('aria-label') || 'Video';

    iframe.allow =
      'autoplay; fullscreen; encrypted-media; picture-in-picture';

    iframe.allowFullscreen = true;
    iframe.loading = 'eager';


    shell.innerHTML = '';
    shell.appendChild(iframe);

  });


  /*
   * =========================================
   * INITIALIZATION
   * =========================================
   */

  function initAll(scope) {
    initAllGalleries(scope);
    initNativeVideoControls(scope);
  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });

  } else {

    initAll(document);

  }


  /*
   * Shopify Theme Editor reload support
   */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

})();